/** Aspect ratios accepted by Gemini's `imageConfig.aspectRatio`. */
export const ASPECT_RATIOS = ['1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'] as const;

export type AspectRatio = (typeof ASPECT_RATIOS)[number];

// Portrait 3:4 suits most house elevation photos.
export const DEFAULT_ASPECT_RATIO: AspectRatio = '3:4';

/** Picks the closest supported output ratio so the render keeps the photo's framing. */
export function detectAspectRatio(width: number, height: number): AspectRatio {
  if (!width || !height) return DEFAULT_ASPECT_RATIO;
  const ratio = width / height;
  if (ratio < 0.65) return '9:16';
  if (ratio < 0.9) return '3:4';
  if (ratio > 1.45) return '16:9';
  if (ratio > 1.1) return '4:3';
  return '1:1';
}
